import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDeskOffice2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="desk-office-2"><path fillRule="evenodd" clipRule="evenodd" d="M5 3.75C5 3.33579 5.33579 3 5.75 3H14.25C14.6642 3 15 3.33579 15 3.75V9.25C15 9.66421 14.6642 10 14.25 10H10.75V11H20.25C20.6642 11 21 11.3358 21 11.75V20.25C21 20.6642 20.6642 21 20.25 21H12.75C12.3358 21 12 20.6642 12 20.25V12.5H4.5V20.25C4.5 20.6642 4.16421 21 3.75 21C3.33579 21 3 20.6642 3 20.25V11.75C3 11.3358 3.33579 11 3.75 11H9.25V10H5.75C5.33579 10 5 9.66421 5 9.25V3.75ZM13.5 15.25H19.5V12.5H13.5V15.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDeskOffice2;
